(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-lavish"] && !Shopify.designMode) return;
  try {
    
(function(){var f=document.getElementById('LqFacetForm');if(!f)return;var sb=document.getElementById('LqSidebar');var mobile=function(){return window.matchMedia('(max-width:900px)').matches};
f.addEventListener('change',function(e){var t=e.target;if(t.id==='LqSort'){document.getElementById('LqSortHidden').value=t.value;f.submit();return}if(t.type==='checkbox'&&!mobile())f.submit();});
f.addEventListener('submit',function(){f.querySelectorAll('input[type=number]').forEach(function(i){if(i.value==='')i.disabled=true});var s=document.getElementById('LqSort');if(s)s.disabled=true;});
var tg=f.querySelector('.lq-filter-toggle summary');if(tg)tg.addEventListener('click',function(e){e.preventDefault();sb.classList.add('is-open');document.body.style.overflow='hidden'});
var c=f.querySelector('[data-lq-close]');if(c)c.addEventListener('click',function(){sb.classList.remove('is-open');document.body.style.overflow=''});})();

  } catch(e) { console.error(e); }
})();
})();
